import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { EditorialMarquee } from "@/components/site/EditorialMarquee";
import { Services } from "@/components/site/Services";
import { Manifesto } from "@/components/site/Manifesto";
import { Stats } from "@/components/site/Stats";
import { Insurance } from "@/components/site/Insurance";
import { RequestForm } from "@/components/site/RequestForm";
import { Testimonials } from "@/components/site/Testimonials";
import { Footer } from "@/components/site/Footer";
import { FloatingWhatsApp } from "@/components/site/FloatingWhatsApp";

export default function Landing() {
  return (
    <main data-testid="landing-page" className="bg-rescue-bg">
      <Header />
      <Hero />
      <EditorialMarquee />
      <Services />
      <Manifesto />
      <Stats />
      <Insurance />
      <RequestForm />
      <Testimonials />
      <Footer />
      <FloatingWhatsApp />
    </main>
  );
}
